<!-- @veltra/icons generated sha256:a3ff703b998d41bc gen:8 source:src/svg/normal/edit.svg -->
<script setup lang="ts">
defineOptions({ name: 'Edit' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="m13.768 4.623-2.53-2.53a.49.49 0 0 1-.013-.699l.008-.008a.507.507 0 0 1 .713 0l2.53 2.53a.49.49 0 0 1 .013.7l-.007.008a.51.51 0 0 1-.714 0m-7.803 8.518-3.613.722A.3.3 0 0 1 2 13.51l.723-3.613L9.32 3.298a.98.98 0 0 1 1.399.002l1.842 1.842a.98.98 0 0 1 .002 1.4zm5.745-7.437-1.552-1.551a.195.195 0 0 0-.278 0L3.643 10.39l-.398 1.992a.2.2 0 0 0 .236.236l1.991-.399 6.237-6.236a.195.195 0 0 0 0-.279"
    />
  </svg>
</template>
